import { render } from "./File.vue?vue&type=template&id=7f236f34&scoped=true&ts=true"
import script from "./File.vue?vue&type=script&lang=ts"
export * from "./File.vue?vue&type=script&lang=ts"

import "./File.vue?vue&type=style&index=0&id=7f236f34&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f236f34"]])

export default __exports__